/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react'
import {Onboarding} from '../onboarding'
// import PageScaffold from '../../components/app/page-scaffold'
// import {BaseLayout} from '../../components/layout'
// import {routes} from '../../utils/config'

const Home = () => {
  return (
    // <BaseLayout>
    //   <PageScaffold pageTitle={routes.home.name}>
    //     <Onboarding />
    //   </PageScaffold>
    // </BaseLayout>
    <Onboarding />
  )
}

export default Home
